import type { FC, SVGProps } from 'react';

export const AISummaryIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="white"
      d="M12.7675 25.337C12.7675 30.5581 21.8814 29.7423 21.8814 29.7423V25.9896V10C21.8814 10 12.7675 19.1369 12.7675 25.337Z"
    />
    <path
      fill="#8ECFF8"
      d="M6.58301 18.6475C1.37504 18.6475 2.02604 10 2.02604 10H5.76927H21.7187C21.8814 10 12.7675 18.6475 6.58301 18.6475Z"
    />
    <path
      fill="white"
      d="M23 1C23.2489 3.09744 24.9026 4.75114 27 5C24.9026 5.24886 23.2489 6.90256 23 9C22.7511 6.90256 21.0974 5.24886 19 5C21.0974 4.75114 22.7511 3.09744 23 1Z"
    />
    <path
      fill="white"
      d="M27 9C27.1866 10.5731 28.4269 11.8134 30 12C28.4269 12.1866 27.1866 13.4269 27 15C26.8134 13.4269 25.5731 12.1866 24 12C25.5731 11.8134 26.8134 10.5731 27 9Z"
    />
  </svg>
);
